import moment from "moment";
import { Cell } from "react-table";
import { CctvDevice } from "src/api/cctv/cctv-types";
import { BaseTooltip } from "src/components";
import DetailLink from "src/components/DetailLink";
import { PagePath } from "src/pages/product/details";
import { ViewYmdFormat, YmdFormat } from "src/utils";

const cctvListColumns = [
  {
    Header: "CCTV ID",
    accessor: "id",
    width: 120,
    Cell: (props: Cell<CctvDevice>) => {
      const detailPath = `${PagePath.cctv.detail.replace(":id", `${props.value}`)}`;
      return (
        <div>
          <DetailLink className="text-underline" to={detailPath}>
            {props.value || "-"}
          </DetailLink>
        </div>
      );
    },
  },
  {
    Header: "Camera Group",
    accessor: "cameraGroup",
    width: 160,
    Cell: (props: Cell<CctvDevice>) => {
      return <BaseTooltip className="text-left w-full" contents={props.value || "-"} />;
    },
  },
  {
    Header: "Camera ID",
    accessor: "cameraId",
    width: 120,
    Cell: (props: Cell<CctvDevice>) => {
      return <BaseTooltip className="text-left w-full" contents={props.value || "-"} />;
    },
  },
  {
    Header: "장치명",
    accessor: "name",
    width: 240,
    Cell: (props: Cell<CctvDevice>) => {
      return <BaseTooltip className="text-left w-full" contents={props.value || "-"} />;
    },
  },
  {
    Header: "기기명(노출)",
    accessor: "displayName",
    width: 240,
    Cell: (props: Cell<CctvDevice>) => {
      const displayName = props?.row?.original?.cctvDevicePartnerList?.[0]?.displayName || "-";
      return <BaseTooltip className="text-left w-full" contents={displayName} />;
    },
  },
  {
    Header: "건물명",
    accessor: "buildingName",
    width: 160,
    Cell: (props: Cell<CctvDevice>) => {
      const buildingName = props?.row?.original?.cctvDevicePartnerList?.[0]?.buildingName;
      return <BaseTooltip className="text-left w-full" contents={buildingName || "-"} />;
    },
  },
  {
    Header: "층",
    accessor: "floorNum",
    width: 80,
    Cell: (props: Cell<CctvDevice>) => {
      const floorNum = props?.row?.original?.cctvDevicePartnerList?.[0]?.floorNum;
      return <p className="w-100 text-center">{floorNum ? `${floorNum > 0 ? "지상" : "지하"} ${Math.abs(floorNum)}층` : "-"}</p>;
    },
  },
  {
    Header: "최종 수정일시",
    accessor: "modifiedDate",
    width: 160,
    Cell: (props: Cell<CctvDevice>) => {
      return <p className="text-center">{props.value ? moment(props.value).format(YmdFormat.FULL) : "-"}</p>;
    },
  },
];

export default cctvListColumns;
